// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/weather-observations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/weather-observations/weather-observations.js';

mount([g0]);
